/* eslint-disable no-unused-vars */
import React from 'react';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

interface InputFormProps {
  userHasSearch?: boolean;
  hasLicense?: boolean;
  licenseMsg?: any;
}

const LicenseRes: React.FC<InputFormProps> = ({ hasLicense, licenseMsg }) => {
  return (
    <>
      <div
        className='screening-search-container-full'
        style={{ gap: '14px', paddingTop: '5px' }}
      >
        {hasLicense &&
          licenseMsg?.result?.heading ===
            'License Requirement Important Note!' && (
            <div className='screening-ai-containers-warning'>
              <div style={{ width: '100%' }}>
                <div className='api-container-left'>
                  <div
                    className='screening-ai-label-text'
                    style={{
                      marginBottom: '0.5rem',
                      display: 'flex',
                      alignItems: 'center',
                      color: '#FACC14',
                    }}
                  >
                    <WarningAmberOutlinedIcon
                      style={{ marginRight: '10px', color: '#FACC14' }}
                    />
                    License Requirement Important Note!
                  </div>
                  <div className='screening-ai-sum-groups'>
                    <div
                      className='screening-ai-sum-header-texts'
                      style={{ color: 'var(--bg-license)' }}
                    >
                      {licenseMsg?.result?.text}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
      </div>
    </>
  );
};

export default LicenseRes;
